import { useMutation, type UseMutationResult } from "@tanstack/react-query"

import type {
  GenesysInstallationClaimRequest,
  GenesysInstallationClaimResponse,
} from "../types"
import { useBillingClient } from "./useBillingClient"

/** Claims a provider-verified Genesys installation for the signed-in user. */
export function useGenesysInstallationClaim(): UseMutationResult<
  GenesysInstallationClaimResponse,
  Error,
  GenesysInstallationClaimRequest
> {
  const client = useBillingClient()

  return useMutation<
    GenesysInstallationClaimResponse,
    Error,
    GenesysInstallationClaimRequest
  >({
    mutationFn: (input) => client.claimGenesysInstallation(input),
  })
}
